<dynamic-form
  [group]="group"
  [serviceName]="'AuthFlowSetupService'"
  [loading]="loading"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  [formErrors]="formErrors"
  #form="dynamicForm"
  (submit)="submit($event)"
  (modalOutput)="handleModalOutput($event)"
  (formChanges)="handleFormChanges($event)"
>
</dynamic-form>

<base-table-layout
  [records]="grid"
  [footer]="footer"
  [gridActions]="gridActions"
  [hasRowCheckbox]="hasRowCheckbox"
  [settings]="columnSetting"
  [searched]="searched"
  [loading]="loading"
  [downloading]="downloading"
  [checkboxLoading]="checkboxLoading"
  [count]="count"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  (outputMethodHandler)="outputMethodHandler($event)"
  [sortNum]="sortNum"
  [sortDir]="sortDir"
  (changeSortHandler)="changeSort($event)"
  [pageSize]="pageSize"
  [pageNum]="pageNum"
  [pageMax]="pageMax"
  (changePageHandler)="changePage($event)"
  (changePageSizeHandler)="changePageSize($event)"
>
</base-table-layout>

<div class="card"  *ngIf="!loading && !fourEyes" >
  <div class="card-header">
    <strong>{{genericVisuals?.requestForApprovalGridTitle}}</strong>
    <a
        href="javascript:void(0);"
        role="button"
        class="pull-right"
        (click)="isCollapsed = !isCollapsed"
      >
        @if (isCollapsed) {
          <i class="fa fa-plus-circle"></i>
        } @else {
          <i class="fa fa-minus-circle"></i>
        }
      </a>
  </div>
  <div class="card-block p-0" [collapse]="isCollapsed">
    <requestsForApproval [selectorName]="'authFlowSetupEdit-grid'"></requestsForApproval>
  </div>
</div>
